<template>
  <sub-page title="我的办件">
    <div class="todo-page">
      <!-- 顶部状态Tab：待提交/办理中/已办结/待评价，默认待提交；底部滑动指示条 -->
      <div class="tab-bar">
        <div
          v-for="tab in tabs"
          :key="tab.key"
          class="tab-item"
          :class="{ active: activeTab === tab.key }"
          @click="activeTab = tab.key"
        >{{ tab.label }}({{ tab.count }})</div>
        <div class="tab-indicator" :style="indicatorStyle"></div>
      </div>

      <!-- 搜索框：搜索图标左对齐，placeholder居中 -->
      <div class="search-bar">
        <svg viewBox="0 0 24 24" class="search-icon"><circle cx="11" cy="11" r="7" fill="none" stroke="#999" stroke-width="2"/><path d="M16 16 L21 21" stroke="#999" stroke-width="2" stroke-linecap="round"/></svg>
        <input v-model="keyword" class="search-input" placeholder="请输入办件业务关键词" />
      </div>

      <!-- 提示条 -->
      <div class="tip-bar">
        <svg viewBox="0 0 24 24" class="tip-icon"><circle cx="12" cy="12" r="10" fill="none" stroke="#F0A230" stroke-width="2"/><path d="M12 8 L12 13" stroke="#F0A230" stroke-width="2" stroke-linecap="round"/><circle cx="12" cy="16.5" r="1.2" fill="#F0A230"/></svg>
        温馨提示：您可以通过搜索快速查找办件
      </div>

      <!-- 空状态 -->
      <div class="empty-state">
        <img :src="emptyImg" class="empty-img" alt="empty" />
        <div class="empty-text">暂无{{ activeLabel }}数据</div>
      </div>
    </div>
  </sub-page>
</template>

<script>
import SubPage from './SubPage.vue'

export default {
  name: 'MyTodo',
  components: { SubPage },
  data() {
    return {
      keyword: '',
      activeTab: 'pending',
      tabs: [
        { key: 'pending', label: '待提交', count: 0 },
        { key: 'processing', label: '办理中', count: 0 },
        { key: 'done', label: '已办结', count: 0 },
        { key: 'evaluate', label: '待评价', count: 0 }
      ],
      emptyImg: require('@/assets/icons/empty.png')
    }
  },
  computed: {
    activeLabel() {
      const tab = this.tabs.find(t => t.key === this.activeTab)
      return tab ? tab.label : ''
    },
    // 滑动指示条位置：随选中tab平移（translateX 百分比基于指示条自身宽度=单个tab宽）
    indicatorStyle() {
      const idx = this.tabs.findIndex(t => t.key === this.activeTab)
      return {
        width: 100 / this.tabs.length + '%',
        transform: 'translateX(' + idx * 100 + '%)'
      }
    }
  }
}
</script>

<style scoped>
.todo-page {
  background: #F3F8FB;
  min-height: 100%;
  padding: calc(24 * var(--w));
}
.search-bar {
  display: flex;
  align-items: center;
  margin-top: calc(24 * var(--w));
  height: calc(88 * var(--w));
  background: #fff;
  border-radius: calc(44 * var(--w));
  padding: 0 calc(28 * var(--w));
  gap: calc(12 * var(--w));
  box-shadow: 0 calc(4 * var(--w)) calc(16 * var(--w)) rgba(0, 0, 0, 0.06);
}
.search-icon {
  width: calc(36 * var(--w));
  height: calc(36 * var(--w));
  flex-shrink: 0;
}
.search-input {
  flex: 1;
  border: none;
  outline: none;
  font-size: calc(28 * var(--w));
  color: #323233;
  background: transparent;
  /* placeholder居中展示 */
  text-align: center;
}
.search-input::placeholder {
  color: #969799;
}
.tip-bar {
  margin-top: calc(20 * var(--w));
  padding: calc(18 * var(--w)) calc(24 * var(--w));
  background: #FFF6E8;
  border-radius: calc(12 * var(--w));
  font-size: calc(26 * var(--w));
  color: #F0A230;
  display: flex;
  align-items: center;
  gap: calc(10 * var(--w));
}
.tip-icon {
  width: calc(30 * var(--w));
  height: calc(30 * var(--w));
  flex-shrink: 0;
}
.tab-bar {
  position: relative;
  display: flex;
  /* 覆盖底部TabBar泄漏的全局 .tab-bar 规则（height:150/grid），避免tab条被撑高 */
  height: calc(76 * var(--w));
  align-items: stretch;
  z-index: auto;
  margin-top: 0;
  border-top: none;
  background: #fff;
  border-radius: calc(16 * var(--w));
  box-shadow: 0 calc(4 * var(--w)) calc(16 * var(--w)) rgba(0, 0, 0, 0.06);
}
.tab-item {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  height: calc(76 * var(--w));
  line-height: 1;
  font-size: calc(28 * var(--w));
  color: #666;
  cursor: pointer;
  transition: color 0.2s;
}
.tab-item.active {
  color: #2E8CF6;
  font-weight: 500;
}
/* 底部滑动指示条：短粗圆角条，随选中tab平滑平移 */
.tab-indicator {
  position: absolute;
  left: 0;
  bottom: 0;
  display: flex;
  justify-content: center;
  transition: transform 0.25s ease;
}
.tab-indicator::after {
  content: '';
  width: calc(48 * var(--w));
  height: calc(6 * var(--w));
  border-radius: calc(3 * var(--w));
  background: #2E8CF6;
}
.empty-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-top: calc(140 * var(--w));
}
.empty-img {
  width: calc(240 * var(--w));
  height: calc(240 * var(--w));
  object-fit: contain;
  opacity: 0.9;
}
.empty-text {
  margin-top: calc(24 * var(--w));
  font-size: calc(30 * var(--w));
  color: #969799;
}
</style>



// WEBPACK FOOTER //
// src/pages/MyTodo.vue